<template>
    <aside class="is-meta-category">
        <collapsible-card-header :fallback-icon="icon" :open="showBody" :can-open="canCollapse" @click="toggleBody">
            {{ title }}

            <template #items>
                <slot name="actions" />
            </template>
        </collapsible-card-header>

        <div v-if="showBody" class="is-meta-category-body">
            <slot v-if="!!$slots.default" name="default" />

            <p v-else class="has-text-subtle">{{ bodyFallback }}</p>
        </div>
    </aside>
</template>

<script>
import CollapsibleCardHeader from '@/components/elements/CollapsibleCardHeader.vue';

export default {
    name: 'MetaCategory',

    components: { CollapsibleCardHeader },

    props: {
        icon: {
            default: 'question-circle',
            type: String,
        },
        title: {
            default: 'Information',
            type: String,
        },
        bodyFallback: {
            default: 'Information',
            type: String,
        },
        canCollapse: {
            default: true,
            type: Boolean,
        },
    },

    data() {
        return {
            showBody: true,
        };
    },

    watch: {
        // Watch for changes to the store's dark theme preference
        '$store.state.User.dark_theme_preference': {
            handler() {
                this.updateDarkModeClass();
            },
            immediate: true,
        },
    },

    mounted() {
        this.updateDarkModeClass();
    },

    methods: {
        updateDarkModeClass() {
            // Check if the HTML element actually has the dark-mode class
            // This reflects the actual active state considering system preferences
            const htmlHasDarkMode = document.documentElement.classList.contains('dark-mode');

            if (htmlHasDarkMode) {
                document.body.classList.add('dark-mode');
            } else {
                document.body.classList.remove('dark-mode');
            }
        },

        toggleBody() {
            if (!this.canCollapse) return;

            this.showBody = !this.showBody;
        },
    },
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.is-meta-category {
    border-bottom: 1px solid $border;

    &:last-child {
        border-bottom: 0;
    }

    &-body {
        padding: $card-content-padding;
        padding-top: 0;
    }

    .tag {
        background: $white;

        a {
            color: $text-subtle;
            font-size: $medium-font-size;
            font-weight: $weight-medium;
        }
    }
}

.dark-mode {
    .is-meta-category {
        .tag {
            a {
                color: black;
            }
        }
    }
}
</style>
